import './opening-hours-list-item.scss';

import { kebabCase } from 'lodash';

import { OpeningHoursGroupedItem } from './opening-hours-list.types';

type OpeningHoursListItemProps = {
  item: OpeningHoursGroupedItem;
};

export function OpeningHoursListItem({ item }: OpeningHoursListItemProps) {
  const formattedDate = item.date.charAt(0).toUpperCase() + item.date.slice(1);
  return (
    <div className="opening-hours-list-item">
      <div className="opening-hours-list-item__content">
        <h2>{formattedDate}</h2>
        <div className="opening-hours-items">
          {item.items.map(timeItem => (
            <div
              key={timeItem.startTime}
              className={`opening-hours-items__item opening-hours-items__item--${kebabCase(
                timeItem.status
              )}`}
            >
              <h3>
                {timeItem.startTime} - {timeItem.endTime} : {timeItem.status}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
